import React from 'react'
import { Column, Grid } from 'src/components/framework/ui'
import { LinksList } from 'src/components/page/layout/footer/links-list'
import { usePageContext } from 'src/contexts/page.context'

import * as styles from './site-links.module.scss'

export const SiteLinks: React.FC = () => {
  const { siteUrl } = usePageContext()
  return (
    <div className={styles.siteLinks}>
      <Grid>
        <Column ts={3} msm={12}>
          <LinksList
            title="Stockopedia"
            links={{
              'StockRanks Performance': `${siteUrl}/stockranks/performance/`,
              'About Us': `${siteUrl}/about/`,
              Careers: `${siteUrl}/careers/`,
            }}
          />
        </Column>

        <Column ts={3} msm={12}>
          <LinksList
            title="Top Stocks"
            links={{
              UK350: `${siteUrl}/top-stocks/gb`,
              US350: `${siteUrl}/top-stocks/us`,
              ASX350: `${siteUrl}/top-stocks/au`,
              FR350: `${siteUrl}/top-stocks/fr`,
              SGP350: `${siteUrl}/top-stocks/sg`,
            }}
          />
        </Column>

        <Column ts={3} msm={12}>
          <LinksList
            title="Exchanges"
            links={{
              LSE: `${siteUrl}/exchanges/london-stock-exchange-LSE`,
              ASX: `${siteUrl}/exchanges/australian-stock-exchange-seats-ASX`,
              NYSE: `${siteUrl}/exchanges/new-york-stock-exchange-NYQ`,
              NASDAQ: `${siteUrl}/exchanges/nasdaq-global-select-market-NSQ`,
              'All Exchanges': `${siteUrl}/exchanges`,
            }}
          />
        </Column>

        <Column ts={3} msm={12}>
          <LinksList
            title="Legals"
            links={{
              'Privacy Policy': `${siteUrl}/learn/account-billing/privacy-policy-463148`,
              'Terms & Conditions': `${siteUrl}/learn/account-billing/terms-of-use-463173/`,
              Disclaimer: `${siteUrl}/learn/account-billing/disclaimer-463143/`,
              Cookies: `${siteUrl}/learn/account-billing/cookies-463188/`,
            }}
          />
        </Column>
      </Grid>
    </div>
  )
}
